const firebaseConfig = {
  apiKey: "AIzaSyCThSbjZSKyQlKNLjHAAFWaoT7f5sRKfFo",
  authDomain: "volition-page.firebaseapp.com",
  databaseURL: "https://volition-page.firebaseio.com",
  projectId: "volition-page",
  storageBucket: "volition-page.appspot.com",
  messagingSenderId: "1005354380725",
  appId: "1:1005354380725:web:3d69c9d7c75999c7"
};

export { firebaseConfig };
